export default {
  path: "mail_subjects",
  name: "mail_subjects",
  meta: {
    label: "Mail Subjects",
  },
  props: true,
  component() {
    return import("@/components/MailSubjects/MailSubjects.vue");
  },
};
